import { render, staticRenderFns } from "./MotionTab.vue?vue&type=template&id=6b9f918a"
import script from "./MotionTab.vue?vue&type=script&lang=ts"
export * from "./MotionTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports